import { config } from "../../config/domain";
import { isLoggedIn, getUserID } from "./login/loginService";

declare var dataLayer: any;

export interface ValueInterface {
	category: string;
	action: string;
	event: string;
	// either label or labelUrl should be present
	label?: string;
	labelUrlA?: string; // Angular site url - enter only the url after origin url (rest be added automatically). If labelUrlA present, then label will be replaced.
	labelUrlR?: string; // React site url - enter only the url after origin url (rest be added automatically). If labelUrlR present, then label and labelUrlA will be replaced.
}

/**
 * Single function that handles GA events
 * @param value if any value is not defined, then pass blank string
 * @param user_id user id. If user is already logged in, then this will automatically pick up logged in user's userid
 * @param href href to pass if there is any
 * @param position position to pass if there is any
 * @param searchtext search text to pass if there is any
 */
export default function gtmService(value: ValueInterface, user_id?: string, href?: string, position?: string, searchtext?: string) {
	if (value.labelUrlR) {
		value.label = window.location.origin + process.env.PUBLIC_URL + "/" + value.labelUrlR;
	} else if (value.labelUrlA) {
		value.label = config.rootUrl + value.labelUrlA;
	}
	delete value.labelUrlA;
	delete value.labelUrlR

	if (!user_id && isLoggedIn()) {
		user_id = getUserID()!;
	}

	let data = { ...value, user_id, href, position, searchtext };

	dataLayer.push(data);
}
